import { useSelector } from "react-redux";
import { useMemo } from "react";
import useSidebar from "../data/sidebarMenus";
import { getFilteredSellerMenus } from "../data/sellerSidebarMenus";
import { getFilteredServiceProviderMenus } from "../data/serviceProviderSidebarMenus";
import { selectPermissions, selectIsSuperAdmin, selectRole } from "../store/auth";
import { ROLES } from "../constants/roles";

export default function useSidebarMenus() {
  const permissions = useSelector(selectPermissions);
  const isSuperAdmin = useSelector(selectIsSuperAdmin);
  const userRole = useSelector(selectRole);
  const { menus } = useSidebar();

  const sidebarMenus = useMemo(() => {
    if (!permissions.length) return [];
    
    // Super admin gets all admin menus
    if (isSuperAdmin) {
      return menus;
    }

    // Role-based menu selection
    switch (userRole) {
      case ROLES.SELLER:
        return getFilteredSellerMenus(permissions);
        
      case ROLES.SERVICE:
        return getFilteredServiceProviderMenus(permissions);
        
      case ROLES.ADMIN:
      case ROLES.SUPER_ADMIN:
        // Admin users get filtered admin menus
        let filteredMenus = [];
        menus.forEach((menu) => {
          const filtered = menu[1].filter((men) =>
            permissions?.includes(men.permission)
          );
          if (filtered.length > 0) {
            filteredMenus.push([menu[0], filtered]);
          }
        });
        return filteredMenus;
        
      default:
        // Default case - filter admin menus by permissions
        let defaultFilteredMenus = [];
        menus.forEach((menu) => {
          const filtered = menu[1].filter((men) =>
            permissions?.includes(men.permission)
          );
          if (filtered.length > 0) {
            defaultFilteredMenus.push([menu[0], filtered]);
          }
        });
        return defaultFilteredMenus;
    }
  }, [permissions, isSuperAdmin, userRole, menus]);

  return sidebarMenus;
}
